<template>
  <div>
    <WebhooksEdit
      :item="currentItem"
      :update="updateItem"
      :close="closeEdit"
      :eventos="eventos"
    />
    <Loading :isActive="loading" />
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Webhooks">
        <WebhooksTable
          :items="items"
          :eventos="eventos"
          :openEdit="openEdit"
          :openCreate="openCreate"
          :deleteConfirm="deleteConfirm"
        />
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import clone from "just-clone";
import { get, post, put, del } from "@/helpers/apiRequest";
import WebhooksEdit from "./components/WebhooksEdit";
import WebhooksTable from "./components/WebhooksTable";

const Item = {
  id: null,
  titulo: "",
  url: "",
  evento: "",
  ativo: 1,
};

export default {
  name: "webhooks",
  components: {
    WebhooksEdit,
    WebhooksTable,
  },
  data() {
    return {
      loading: false,
      items: [],
      eventos: [],
      currentItem: {},
    };
  },
  methods: {
    loadWebhooks() {
      this.loading = true;
      get("/admin/webhooks")
        .then((json) => {
          this.items = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadEventos() {
      get("/admin/webhooks/eventos")
        .then((json) => {
          this.eventos = json;
        })
        .catch(() => {});
    },
    openCreate() {
      this.currentItem = clone(Item);
      this.$modal.show("webhooksEdit");
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.$modal.show("webhooksEdit");
    },
    closeEdit() {
      this.$modal.hide("webhooksEdit");
    },
    doRequest() {
      return this.currentItem.id
        ? put(`/admin/webhooks/${this.currentItem.id}`, this.currentItem)
        : post("/admin/webhooks", this.currentItem);
    },
    updateItem() {
      this.doRequest()
        .then((json) => {
          this.closeEdit();
          this.loadWebhooks();
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa acao nao podera ser desfeita",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/webhooks/${id}`)
              .then(() => {
                this.loading = false;
                this.$swal({
                  title: "Removido com sucesso",
                  icon: "success",
                });
                this.loadWebhooks();
              })
              .catch(() => {
                this.loading = false;
                this.$swal({
                  title: "Falha ao remover",
                  icon: "error",
                });
              });
          }
        })
        .catch(() => {});
    },
  },
  beforeMount() {
    this.loading = true;
    this.loadWebhooks();
    this.loadEventos();
  },
};
</script>
